import { Directive, HostListener,Input,OnInit,ElementRef,Renderer2, SimpleChanges, Inject} from '@angular/core';
import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service';

@Directive({
	selector: '[abs-flyout-toggle-directive]'
})
export class AbsFlyoutToggleDirective implements OnInit {

	
	@Input('horizontalFlag') horizontalFlag:string;
	@Input('verticalFlag') verticalFlag: string;
	public b2bFlyoutContainer: any;
	public b2bFlyoutElement: any;
	public b2bFlyoutContainerNotClicked: any;
	public actionElementWidth: any;
	public offsetWidth: string;
	public offsetHeight: string;
	public launchingElement:any;
	public firstElement:any;
	public lastElement:any;
	

	constructor(
		@Inject(ElementRef) private elementRef:ElementRef,
		@Inject(Renderer2) private renderer:Renderer2,
		@Inject(AbsDomHelperService) private domHelper:AbsDomHelperService,
	) { }

	ngOnInit(){
	}


	@HostListener ('document:click', ['$event.target'])
	public OnClick(targetElement){
		if(this. elementRef.nativeElement.contains(targetElement)){
			this.b2bFlyoutContainer = this.elementRef.nativeElement.querySelector('.b2b-flyout-container');

			if(this.b2bFlyoutContainer.classList.contains('b2b-flyout-closed')){
				this.setStyles([{element: this.b2bFlyoutContainer, property: 'display', propertyValue: 'block'}]);
				this.setHorizontalPosition(this.horizontalFlag, this.elementRef.nativeElement);
				this.setVerticalPosition(this.verticalFlag, this.elementRef.nativeElement)
				this.addClass(this.b2bFlyoutContainer, 'b2b-flyout-open');
				this.removeClasses([{element:this.b2bFlyoutContainer, className: 'b2b-flyout-closed'}]);
				const el = this.elementRef.nativeElement;
				this.firstElement = this.domHelper.firstTabableElement(el);
				this.lastElement = this.domHelper.lastTabableElement(el);
				if(this.lastElement){
					this.lastElement.addEventListener('keydown', this.onClick.bind(this));
				}
				if (this.firstElement) {
					this.firstElement.focus();
				}
			}
			else if(this.b2bFlyoutContainer.classList.contains('b2b-flyout-open') && targetElement.classList.contains('close-flyout')){
				this.closeFlyout(this.b2bFlyoutContainer);
			}

		}
		else{
			this.b2bFlyoutContainerNotClicked = this.elementRef.nativeElement.querySelector('.b2b-flyout-container');
			if(this.b2bFlyoutContainerNotClicked.classList.contains('b2b-flyout-open')){
				this.closeFlyout(this.b2bFlyoutContainerNotClicked);
			}
		}
	}
	
	public setStyles(array){
		for(let i=0; i<array.length; i++){
			this.renderer.setStyle(array[i].element, array[i].property, array[i].propertyValue);
		}
	}

	public removeClasses(array){
		for(let i=0; i < array.length; i++){
			this.renderer.removeClass(array[i].element, array[i].className);
		}
	}
	
	public addClass(element, className){
		this.renderer.addClass(element,className);
	}

	public closeFlyout(b2belement){
		this.setStyles([{element: b2belement, property: 'display', propertyValue: 'none'}]);
		this.addClass(b2belement, 'b2b-flyout-closed');
		this.removeClasses([{element: b2belement, className: 'b2b-flyout-open'}]);
	}

	public setHorizontalPosition(horizontalPostion, nativeelement){	
		 this.b2bFlyoutElement = nativeelement.querySelector('.b2b-flyout-container');
		if(horizontalPostion==='center'){
			this.offsetWidth= (nativeelement.getBoundingClientRect().width/2) - (this.b2bFlyoutElement.getBoundingClientRect().width/2)-8+'px';
			this.setStyles([{element: this.b2bFlyoutElement, property: 'margin-left',propertyValue: this.offsetWidth},
							{element: this.b2bFlyoutElement, property: 'left',propertyValue: '0px'},
							{element: this.b2bFlyoutElement, property: 'right',propertyValue: 'auto'}
						]);
			this.removeClasses([{element: this.b2bFlyoutElement, className: 'b2b-flyout-left'},
								{element: this.b2bFlyoutElement, className: 'b2b-flyout-right'}
							]);
			this.addClass(this.b2bFlyoutElement, 'b2b-flyout-center')
		}
		else if(horizontalPostion==='left'){
			this.offsetWidth = (nativeelement.getBoundingClientRect().width/2)-23+'px';
			this.setStyles([{element: this.b2bFlyoutElement, property: 'margin-left',propertyValue: '0px'},
							{element: this.b2bFlyoutElement, property: 'left',propertyValue: this.offsetWidth},
							{element: this.b2bFlyoutElement, property: 'right',propertyValue: 'auto'}
						]);
			this.removeClasses([{element: this.b2bFlyoutElement, className: 'b2b-flyout-center'},
								{element: this.b2bFlyoutElement, className: 'b2b-flyout-right'}
				]);
			this.addClass(this.b2bFlyoutElement, 'b2b-flyout-left')
		}
		else{
			this.offsetWidth = (nativeelement.getBoundingClientRect().width/2)-23+'px';
			this.setStyles([{element: this.b2bFlyoutElement, property: 'margin-left',propertyValue: '0px'},
							{element: this.b2bFlyoutElement, property: 'left',propertyValue: 'auto'},
							{element: this.b2bFlyoutElement, property: 'right',propertyValue: this.offsetWidth}
						]);
			this.removeClasses([{element: this.b2bFlyoutElement, className: 'b2b-flyout-left'},
								{element: this.b2bFlyoutElement, className: 'b2b-flyout-center'}
			]);
			this.addClass(this.b2bFlyoutElement, 'b2b-flyout-right')
		}
	}

	public setVerticalPosition(verticalPostion, nativeelement){
		this.b2bFlyoutElement = nativeelement.querySelector('.b2b-flyout-container');
		if(verticalPostion==='above'){
			this.offsetHeight = this.b2bFlyoutElement.getBoundingClientRect().height+35;
			this.setStyles([{element: this.b2bFlyoutElement, property: 'margin-top', propertyValue: '-'+this.offsetHeight.toString()+'px'}]);
			this.removeClasses([{element: this.b2bFlyoutElement, className: 'b2b-flyout-below'}]);
			this.addClass(this.b2bFlyoutElement, 'b2b-flyout-above');
		}
		else{
			this.setStyles([{element: this.b2bFlyoutElement, property: 'margin-top', propertyValue: '13px'}]);
			this.removeClasses([{element: this.b2bFlyoutElement, className: 'b2b-flyout-above'}]);
			this.addClass(this.b2bFlyoutElement, 'b2b-flyout-below');
		}
	}

	public onClick(event) {
		if(event.key=='Tab' && event.type=='keydown'){
			if(event.currentTarget.closest('.b2b-flyout-container').classList.contains('b2b-flyout-open')){
				event.currentTarget.closest('.actionsFlyoutElement').querySelector('.togglerLink').focus();
				this.closeFlyout(event.currentTarget.closest('.b2b-flyout-container'));
				event.stopPropagation();
				event.preventDefault();
			}
		}
	}
}
